// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__2phTg"};